import classNames from 'classnames';
import { Button, SvgAnimation } from '@/components/standalone';
import styles from './PlatformsIntroSection.module.scss';

function PlatformsIntroSection() {
  return (
    <div
      className={classNames('section', styles.platformsIntroSection)}
      id="first"
    >
      <div className="max-content-width">
        <div>
          <h1>Build user-friendly & secured-by-default apps</h1>
          <p>
            Boost your platform and make it easy to onboard users by providing
            them visual indicators on what&apos;s a safe bet and what&apos;s
            not. Enhance your protocols by leveraging Trusblock&apos;s critical
            data.
          </p>
          <div>
            <Button
              type="link"
              href="https://app.trustblock.run/sign-up?type=integrator"
              icon="LogIn"
            >
              Use our API for free
            </Button>
            <Button
              type="link"
              mode="outline"
              href="https://app.trustblock.run"
            >
              Go to app
            </Button>
          </div>
        </div>
        <div>
          <SvgAnimation name="Platforms" autoplay />
        </div>
      </div>
    </div>
  );
}

export default PlatformsIntroSection;
